(() => {
  'use strict';
  if (window.yndRecentlyViewed) { window.yndRecentlyViewed(); return; }
  const storageKey = 'ynd.recently-viewed.v1';
  const limit = 12;
  const recorded = new Set();
  let permission = null;
  let storageAvailable = true;
  let entries = [];
  let privacyTimer;

  function productPath(value) {
    if (typeof value !== 'string' || value.length > 512) return '';
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password) return '';
      if (!/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,4})?\/)?products\/[a-z0-9][a-z0-9%_-]*\/?$/i.test(url.pathname)) return '';
      if (['ynd-womens-oversized-acid-wash-hoodie', 'ynd-mens-oversized-acid-wash-hoodie'].includes(url.pathname.split('/').filter(Boolean).pop())) return '';
      return url.pathname.replace(/\/$/, '');
    } catch { return ''; }
  }

  function productImage(value) {
    if (typeof value !== 'string' || !value || value.length > 1500) return '';
    try {
      const url = new URL(value, window.location.origin);
      if (url.username || url.password || !['http:', 'https:'].includes(url.protocol)) return '';
      const ownImage = url.origin === window.location.origin && /^\/cdn\/shop\/(?:products|files)\//.test(url.pathname);
      const shopifyImage = url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && /^\/s\/files\//.test(url.pathname);
      if (!ownImage && !shopifyImage) return '';
      const width = url.searchParams.get('width');
      const version = url.searchParams.get('v');
      url.search = '';
      url.hash = '';
      if (version && /^\d{1,20}$/.test(version)) url.searchParams.set('v', version);
      if (width && /^\d{1,4}$/.test(width)) url.searchParams.set('width', width);
      return url.href;
    } catch { return ''; }
  }

  function normalize(value) {
    if (!Array.isArray(value)) return [];
    const seen = new Set();
    return value.slice(0, 100).reduce((list, item) => {
      if (!item || typeof item !== 'object' || typeof item.id !== 'string' || !/^\d{1,30}$/.test(item.id)) return list;
      if (['15422979342617', '15422981341465'].includes(item.id)) return list;
      const url = productPath(item.url);
      const title = typeof item.title === 'string' ? item.title.trim().slice(0, 300) : '';
      if (!url || !title || seen.has(item.id) || list.length >= limit) return list;
      seen.add(item.id);
      list.push({ id: item.id, title, url, image: productImage(item.image), state: ['preview', 'unavailable'].includes(item.state) ? item.state : 'details' });
      return list;
    }, []);
  }

  function removeHistory() {
    try { window.localStorage.removeItem(storageKey); return true; }
    catch { storageAvailable = false; return false; }
  }

  function readHistory() {
    entries = [];
    storageAvailable = true;
    try {
      const raw = window.localStorage.getItem(storageKey);
      if (!raw) return;
      if (raw.length > 32000) { removeHistory(); return; }
      let parsed;
      try { parsed = JSON.parse(raw); }
      catch { removeHistory(); return; }
      entries = normalize(parsed);
      const clean = JSON.stringify(entries);
      if (clean !== raw) window.localStorage.setItem(storageKey, clean);
    } catch { storageAvailable = false; entries = []; }
  }

  function recordProduct() {
    const product = document.querySelector('[data-ynd-recent-product]');
    if (!product || !storageAvailable) return;
    const item = normalize([{
      id: product.dataset.productId,
      title: product.dataset.productTitle,
      url: product.dataset.productUrl,
      image: product.dataset.productImage,
      state: product.dataset.productState
    }])[0];
    if (!item || productPath(window.location.pathname) !== item.url || recorded.has(item.id)) return;
    entries = [item, ...entries.filter(entry => entry.id !== item.id)].slice(0, limit);
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(entries));
      recorded.add(item.id);
    } catch { storageAvailable = false; entries = []; }
  }

  function render() {
    document.querySelectorAll('[data-ynd-recently-viewed]').forEach(root => {
      const list = root.querySelector('[data-recent-list]');
      const empty = root.querySelector('[data-recent-empty]');
      const note = root.querySelector('[data-recent-note]');
      const clear = root.querySelector('[data-recent-clear]');
      if (!list || !empty || !note || !clear) return;
      list.replaceChildren();
      const canShow = permission === true && storageAvailable;
      const requestedLimit = Number(root.dataset.recentLimit);
      const displayLimit = Number.isInteger(requestedLimit) && requestedLimit > 0 ? Math.min(requestedLimit, limit) : limit;
      const items = canShow ? entries.slice(0, displayLimit) : [];
      note.textContent = !storageAvailable ? root.dataset.storageUnavailable : permission === false ? root.dataset.consentPaused : permission === null ? root.dataset.privacyUnavailable : root.dataset.browserNote;
      empty.hidden = items.length > 0;
      list.hidden = items.length === 0;
      clear.hidden = !canShow || !items.length;
      items.forEach(item => {
        const row = document.createElement('li');
        row.className = 'ynd-recent-card';
        const link = document.createElement('a');
        link.className = 'ynd-recent-card-link';
        link.href = item.url;
        const visual = document.createElement('span');
        visual.className = 'ynd-recent-card-image';
        visual.setAttribute('aria-hidden', 'true');
        const fallback = document.createElement('span');
        fallback.className = 'ynd-recent-image-fallback';
        fallback.textContent = root.dataset.imageUnavailable;
        visual.append(fallback);
        if (item.image) {
          const image = document.createElement('img');
          image.alt = '';
          image.width = 480;
          image.height = 600;
          image.loading = 'lazy';
          image.decoding = 'async';
          fallback.hidden = true;
          image.addEventListener('error', () => { image.remove(); fallback.hidden = false; }, { once: true });
          image.src = item.image;
          visual.append(image);
        }
        const title = document.createElement('h3');
        title.textContent = item.title;
        const detail = document.createElement('span');
        detail.className = 'ynd-recent-card-detail';
        detail.textContent = item.state === 'preview' ? root.dataset.previewLabel : item.state === 'unavailable' ? root.dataset.unavailableLabel : root.dataset.detailsLabel;
        link.append(visual, title, detail);
        row.append(link);
        list.append(row);
      });
    });
  }

  function refresh() {
    if (permission === true) { readHistory(); recordProduct(); }
    else entries = [];
    render();
  }

  function updatePermission() {
    clearTimeout(privacyTimer);
    try {
      const privacy = window.Shopify?.customerPrivacy;
      permission = typeof privacy?.preferencesProcessingAllowed === 'function' ? privacy.preferencesProcessingAllowed() === true : null;
    } catch { permission = null; }
    if (permission === false) {
      entries = [];
      recorded.clear();
      removeHistory();
    }
    refresh();
  }

  window.yndRecentlyViewed = refresh;
  document.addEventListener('visitorConsentCollected', updatePermission);
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', event => { if (event.persisted) recorded.clear(); updatePermission(); });
  window.addEventListener('storage', event => { if (event.key === storageKey || event.key === null) refresh(); });
  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('[data-recent-clear]') : null;
    const root = button?.closest('[data-ynd-recently-viewed]');
    if (!root) return;
    const cleared = removeHistory();
    entries = [];
    render();
    const status = root.querySelector('[data-recent-status]');
    if (status) status.textContent = cleared ? root.dataset.cleared : root.dataset.clearFailed;
    root.querySelector('[data-recent-heading]')?.focus({ preventScroll: true });
  });
  render();
  if (typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function') updatePermission();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    privacyTimer = setTimeout(() => { permission = null; render(); }, 5000);
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        clearTimeout(privacyTimer);
        if (error) { permission = null; render(); }
        else updatePermission();
      });
    } catch { clearTimeout(privacyTimer); permission = null; render(); }
  }
})();
